import { createStore } from "vuex";
import user from "./modules/user";
import notifications from "./modules/notifications";

export default createStore({
  modules: {
    user,
    notifications,
  },
});
